import { z } from 'zod';
import { DMS_CATEGORIES, DMS_ENTITY_TYPES, DMS_MAX_FILE_BYTES, DMS_MAX_TAGS, DMS_MIME_TYPES, } from '../constants/dms.js';
import { idSchema, isoDateTimeSchema } from './common.js';
import { paginationMetaSchema, paginationQuerySchema } from './pagination.js';
export const dmsEntityTypeSchema = z.enum(DMS_ENTITY_TYPES);
export const dmsCategorySchema = z.enum(DMS_CATEGORIES);
export const dmsMimeTypeSchema = z.enum(DMS_MIME_TYPES);
const optionalText = (max) => z.string().trim().max(max).nullish();
export const dmsTagsSchema = z
    .array(z.string().trim().min(1).max(50))
    .max(DMS_MAX_TAGS)
    .transform((tags) => [...new Set(tags.map((tag) => tag.trim()))]);
export const dmsAttachmentSchema = z.object({
    id: idSchema,
    entityType: dmsEntityTypeSchema,
    entityId: z.string().nullable(),
    fileName: z.string(),
    originalName: z.string(),
    mimeType: z.string(),
    fileSize: z.number().int().min(1).max(DMS_MAX_FILE_BYTES),
    fileHash: z.string().regex(/^[a-f0-9]{64}$/u),
    category: dmsCategorySchema,
    title: z.string().nullable(),
    description: z.string().nullable(),
    tags: z.array(z.string()),
    portalVisible: z.boolean(),
    portalVisibleAt: isoDateTimeSchema.nullable(),
    uploadedByUserId: idSchema,
    uploadedByName: z.string(),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
export const dmsAttachmentLinkSchema = z
    .object({
    id: idSchema,
    attachmentId: idSchema,
    entityType: dmsEntityTypeSchema,
    entityId: idSchema,
    createdByUserId: idSchema,
    createdAt: isoDateTimeSchema,
})
    .strict();
export const dmsAttachmentLinkCreateSchema = z
    .object({
    attachmentId: idSchema,
    entityType: dmsEntityTypeSchema.exclude(['GENERAL']),
    entityId: idSchema,
})
    .strict();
export const dmsUploadMetadataSchema = z
    .object({
    entityType: dmsEntityTypeSchema,
    entityId: idSchema.nullish(),
    category: dmsCategorySchema.default('GENERAL_FILE'),
    title: optionalText(200),
    description: optionalText(4000),
    tags: dmsTagsSchema.default([]),
})
    .superRefine((value, ctx) => {
    if (value.entityType !== 'GENERAL' &&
        (value.entityId === null || value.entityId === undefined)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['entityId'],
            message: 'Für diesen Ablagebereich ist eine Entitäts-ID erforderlich.',
        });
    }
});
export const dmsAttachmentUpdateSchema = z
    .object({
    title: optionalText(200),
    description: optionalText(4000),
    category: dmsCategorySchema.optional(),
    tags: dmsTagsSchema.optional(),
    portalVisible: z.boolean().optional(),
})
    .refine((value) => Object.values(value).some((entry) => entry !== undefined), {
    message: 'Mindestens ein Feld muss aktualisiert werden.',
});
export const dmsListQuerySchema = paginationQuerySchema.omit({ q: true, sort: true }).extend({
    entityType: dmsEntityTypeSchema.optional(),
    entityId: idSchema.optional(),
    category: dmsCategorySchema.optional(),
    search: z.string().trim().min(1).max(200).optional(),
    sort: z
        .enum(['createdAt:asc', 'createdAt:desc', 'originalName:asc', 'originalName:desc'])
        .default('createdAt:desc'),
});
export const dmsListResponseSchema = z.object({
    data: z.array(dmsAttachmentSchema),
    meta: paginationMetaSchema,
});
//# sourceMappingURL=dms.js.map